var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectrico({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_042-enchufe-1",
    "data-name": "042-enchufe-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.66,
    height: 91.639,
    viewBox: "0 0 91.66 91.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    transform: "translate(71.926 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_235",
    "data-name": "Trazado 235",
    d: "M421.06,4.656,416.891.487a1.572,1.572,0,0,0-2.16,0L402.223,13a1.526,1.526,0,0,0,0,2.16l4.169,4.169a1.527,1.527,0,0,0,2.16,0L421.06,6.816A1.526,1.526,0,0,0,421.06,4.656ZM407.472,16.084l-2.009-2.009L415.811,3.727l2.009,2.009Z",
    transform: "translate(-401.775 -0.057)",
    fill: "#003082"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128",
    transform: "translate(64.628 10.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_236",
    "data-name": "Trazado 236",
    d: "M376.049,66.883l-6.1-6.1a4.586,4.586,0,0,0-6.48,0l-2.01,2.009a1.527,1.527,0,0,0,0,2.16l10.425,10.425a1.529,1.529,0,0,0,2.162,0l2.009-2.009A4.586,4.586,0,0,0,376.049,66.883ZM373.887,71.2l-.929.929L364.7,63.866l.929-.929a1.532,1.532,0,0,1,2.16,0l6.1,6.1A1.529,1.529,0,0,1,373.887,71.2Z",
    transform: "translate(-361.006 -59.438)",
    fill: "#003082"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    "data-name": "Grupo 130",
    transform: "translate(39.611 9.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_237",
    "data-name": "Trazado 237",
    d: "M260.092,69.355,248.109,57.372a12.217,12.217,0,0,0-17.279,0l-9.118,9.118a1.527,1.527,0,0,0,0,2.16l27.1,27.1a1.527,1.527,0,0,0,2.16,0l9.118-9.118A12.235,12.235,0,0,0,260.092,69.355Zm-2.16,15.121-8.038,8.038L224.951,67.571l8.038-8.037a9.163,9.163,0,0,1,12.959,0l11.983,11.983A9.176,9.176,0,0,1,257.932,84.476Z",
    transform: "translate(-221.264 -53.793)",
    fill: "#003082"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_132",
    "data-name": "Grupo 132",
    transform: "translate(48.995 15.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131",
    "data-name": "Grupo 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_238",
    "data-name": "Trazado 238",
    d: "M290.881,91.8l-4.17-4.172a5.954,5.954,0,0,0-8.411,0l-4.17,4.172a1.527,1.527,0,0,0,2.16,2.16l4.17-4.172a2.9,2.9,0,0,1,4.091,0l4.17,4.172a1.527,1.527,0,0,0,2.16-2.16Z",
    transform: "translate(-273.681 -85.89)",
    fill: "#86888b"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134",
    transform: "translate(0 71.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_133",
    "data-name": "Grupo 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_239",
    "data-name": "Trazado 239",
    d: "M19.285,406.339l-4.169-4.169a1.527,1.527,0,0,0-2.16,0L.448,414.679a1.526,1.526,0,0,0,0,2.16l4.169,4.169a1.527,1.527,0,0,0,2.16,0L19.285,408.5A1.526,1.526,0,0,0,19.285,406.339ZM5.7,417.768l-2.009-2.009,10.348-10.348,2.009,2.009Z",
    transform: "translate(0 -401.723)",
    fill: "#003082"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_136",
    "data-name": "Grupo 136",
    transform: "translate(10.647 64.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    "data-name": "Grupo 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_240",
    "data-name": "Trazado 240",
    d: "M75.41,371.84,64.985,361.416a1.527,1.527,0,0,0-2.16,0l-2.009,2.009a4.586,4.586,0,0,0,0,6.48l6.1,6.1a4.586,4.586,0,0,0,6.479,0L75.41,374a1.527,1.527,0,0,0,0-2.16Zm-4.166,2.007a1.532,1.532,0,0,1-2.16,0l-6.1-6.1a1.529,1.529,0,0,1,0-2.16l.929-.929,8.265,8.264Z",
    transform: "translate(-59.476 -360.968)",
    fill: "#003082"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_138",
    "data-name": "Grupo 138",
    transform: "translate(9.647 37.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_137",
    "data-name": "Grupo 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_241",
    "data-name": "Trazado 241",
    d: "M97.925,237.193l-27.1-27.1a1.572,1.572,0,0,0-2.16,0l-11.2,11.2a12.235,12.235,0,0,0,0,17.281l11.983,11.983a12.217,12.217,0,0,0,17.281,0l11.2-11.2A1.526,1.526,0,0,0,97.925,237.193ZM84.561,248.4a9.163,9.163,0,0,1-12.959,0L59.619,236.415a9.176,9.176,0,0,1,0-12.959l10.124-10.124,24.94,24.942Z",
    transform: "translate(-53.887 -209.661)",
    fill: "#003082"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140",
    "data-name": "Grupo 140",
    transform: "translate(28.146 31.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139",
    "data-name": "Grupo 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_242",
    "data-name": "Trazado 242",
    d: "M173.381,177.143a4.582,4.582,0,0,0-6.331,0l-9.383,9.381a1.527,1.527,0,0,0,0,2.16l4.169,4.169a1.531,1.531,0,0,0,2.163,0l9.381-9.381a4.475,4.475,0,0,0,0-6.329Zm-2.165,4.167-8.3,8.3-2.009-2.009,8.3-8.3a1.451,1.451,0,0,1,2.009,0,1.42,1.42,0,0,1,0,2.007Z",
    transform: "translate(-157.22 -175.874)",
    fill: "#003082"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    transform: "translate(42.74 46.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_243",
    "data-name": "Trazado 243",
    d: "M254.9,258.465a4.479,4.479,0,0,0-6.331,0l-9.381,9.381a1.527,1.527,0,0,0,0,2.16l4.169,4.169a1.529,1.529,0,0,0,2.16,0l9.383-9.381A4.483,4.483,0,0,0,254.9,258.465Zm-2.162,4.169-8.3,8.3-2.009-2.009,8.3-8.3a1.452,1.452,0,0,1,2.009,0A1.424,1.424,0,0,1,252.738,262.634Z",
    transform: "translate(-238.74 -257.154)",
    fill: "#003082"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(15.636 45.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_244",
    "data-name": "Trazado 244",
    d: "M117.049,275.361,98.287,256.6a1.526,1.526,0,0,0-2.16,0l-8.339,8.339a1.526,1.526,0,0,0,0,2.16l18.764,18.763a1.525,1.525,0,0,0,2.159,0l8.339-8.339A1.526,1.526,0,0,0,117.049,275.361Zm-9.419,7.259-16.6-16.6,6.179-6.179,16.6,16.6Z",
    transform: "translate(-87.339 -256.15)",
    fill: "#86888b"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146",
    transform: "translate(26.06 56.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_245",
    "data-name": "Trazado 245",
    d: "M154.433,321.077l-6.254-6.256a1.527,1.527,0,0,0-2.16,2.16l6.254,6.256a1.527,1.527,0,0,0,2.16-2.16Z",
    transform: "translate(-145.571 -314.374)",
    fill: "#86888b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrico);
export default __webpack_public_path__ + "static/media/electrico.e12460107ca6d169af1da7343d996d18.svg";
export { ForwardRef as ReactComponent };